import { ProjectDetailPage } from '@/pages/projects/ProjectDetailPage';
import { ROUTES } from '@/constants/routes';

export default function CrmProjectDetailPage() {
  return <ProjectDetailPage source="crm" listRoute={ROUTES.CRM_PROJECTS} />;
}
